var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 4.5,
    transform: "rotate(-180 23.5 23.5)",
    fill: "#0E151D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96971 16.773C9.82911 16.6324 9.75012 16.4416 9.75012 16.2428C9.75012 16.0439 9.82911 15.8532 9.96971 15.7125L13.6822 12L9.96971 8.28752C9.83309 8.14607 9.7575 7.95662 9.75921 7.75997C9.76092 7.56332 9.83979 7.37521 9.97885 7.23615C10.1179 7.0971 10.306 7.01822 10.5027 7.01651C10.6993 7.0148 10.8888 7.0904 11.0302 7.22702L15.273 11.4698C15.4136 11.6104 15.4926 11.8011 15.4926 12C15.4926 12.1989 15.4136 12.3896 15.273 12.5303L11.0302 16.773C10.8896 16.9136 10.6988 16.9926 10.5 16.9926C10.3011 16.9926 10.1104 16.9136 9.96971 16.773Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 23.5,
    width: 23,
    height: 23,
    rx: 4.5,
    transform: "rotate(-180 23.5 23.5)",
    stroke: "#313942"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightButton);
export default __webpack_public_path__ + "static/media/arrowRightButton.38eefc2fd0b838d603bf03ec7247ce5a.svg";
export { ForwardRef as ReactComponent };